import type { Resource } from "i18next"
import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import { FALLBACK_LOCALE } from "./locales"

type Options = {
  /** Every catalogue the app ships, the shared namespace included */
  resources: Resource
  namespaces: readonly string[]
  defaultNS: string
}

/**
 * Initialises the i18next singleton the way every app needs it. Call it once,
 * from the app's own i18n module; importing shared code never initialises
 * i18next by itself.
 */
export default function initI18n({
  resources,
  namespaces,
  defaultNS,
}: Options) {
  void i18n.use(initReactI18next).init({
    resources,
    // Bootstrap default; the active locale is set per request by the public
    // $locale route (from the URL) or, in an app, from the signed-in user.
    lng: FALLBACK_LOCALE,
    // Underscored codes opt out of i18next's dash-based language detection,
    // so the regional → language → en chain is spelled out explicitly
    fallbackLng: {
      es_MX: ["es", "en"],
      es: ["en"],
      default: ["en"],
    },
    ns: [...namespaces],
    defaultNS,
    interpolation: {
      // React already escapes interpolated values
      escapeValue: false,
    },
  })

  return i18n
}
